import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

import "./ControlledCarousel_youtube.css";

// src/ImageSlider.js

const ControlledCarousel_youtubeEng = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const images = [
    {
      id: 1,
      src: "image1",
      link: "https://youtu.be/rEtvSkUvj2I",
      alt: "Provide One Stop Integrated Solutions for Mental Health ",
    },
    {
      id: 2,
      src: "image2",
      link: "https://youtu.be/VJVwnHyzGQ8",
      alt: "Mental Health VR Assessment·Education·Training Program",
    },
    {
      id: 3,
      src: "image3",
      link: "https://youtu.be/yySS2ZIEyd0",
      alt: "The 4th K-BIC STAR DAY in 2021",
    },
    {
      id: 4,
      src: "image4",
      link: "https://youtu.be/r99sC1ur-M4",
      alt: "Borderline Personality Disorder fatal to Interpersonal Relations",
    },
    {
      id: 5,
      src: "image5",
      link: "https://youtu.be/ppPUEm99WOk",
      alt: "'How to change 'Intermittent Explosive Disorder' into 'Good Anger Management'",
    },
    {
      id: 6,
      src: "image6",
      link: "https://youtu.be/Uqd4CQhCugI",
      alt: "How to overcome depression and stress caused by COVID-19",
    },
  ];

  return (
    <div className="controlledcarousel_youtubeEng">
      {!isMobileView ? (
        <Carousel>
          {images.map((image) => (
            <Carousel.Item key={image.id}>
              <a href={image.link} target="_blank" rel="noopener noreferrer">
                <div className={`slider-image ${image.src}`}></div>
              </a>
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <div className="vertical-image-list">
          {images.slice(0, 3).map((image) => (
            <a
              key={image.id}
              href={image.link}
              target="_blank"
              rel="noopener noreferrer"
              className="vertical-image-item"
            >
              <div className={`vertical-image ${image.src}`}></div>
            </a>
          ))}
          {showMore &&
            images.slice(3).map((image) => (
              <a
                key={image.id}
                href={image.link}
                target="_blank"
                rel="noopener noreferrer"
                className="vertical-image-item"
              >
                <div className={`vertical-image ${image.src}`}></div>
              </a>
            ))}
          {!showMore && (
            <button
              className="show-more-button"
              onClick={() => setShowMore(true)}
            >
              View More
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ControlledCarousel_youtubeEng;
